import React, { useContext, useEffect, useState } from "react"
import { TouchableOpacity, View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import CustomScrollableContentWithBackHeader from "@Components/CustomScrollableContentWithBackHeader/CustomScrollableContentWithBackHeader"
import SvgSavoirs from "@Components/CustomIcon/Savoirs"
import SvgSavoirFaire from "@Components/CustomIcon/SavoirFaire"
import SvgSavoirEtre from "@Components/CustomIcon/SavoirEtre"
import { QuizzContext } from "@Providers/QuizzProvider"
import { EducatifDiagnoseService } from "@Services/EducatifDiagnose.Service"
import { useRecoilState } from "recoil"
import { allAxisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { ActivityIndicator } from "react-native-paper"
import { PostService } from "@Services/Posts"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { PostCategories } from "@Constants/constant"
import { useUserPrograms } from "../../Hooks/useUserPrograms"

const Knowledge = (props) => {
    const { navigation } = props
    const [diagnosis, setDiagnosis] = useRecoilState(allAxisAtom)
    const [categories, setCategories] = useState([])
    const [loading, setLoading] = useState(false)
    const { setSelectedKnowledge } = useContext(QuizzContext)
    const { disableMenu, fetchingUserPrograms } = useUserPrograms()

    const navigateTo = (args) => {
        const { id, screen, code } = args
        let category = categories.find((item) => item.code === code)
        if (category?.id > 0) {
            setSelectedKnowledge(category?.id)
            navigation.navigate(screen)
        }
    }

    const fetchAllCategories = () => {
        setLoading(true)
        PostService.getCategories()
            .then((response) => {
                const data = response.data.data?.items
                if (data) {
                    setCategories(data)
                }
                setLoading(false)
            })
            .catch((e) => {
                ShowToast({ type: "error", message: "Une erreur est survenue lors de la récuperation des categories" })
                setLoading(false)
            })
    }

    const fetchAllAxis = () => {
        setLoading(true)
        EducatifDiagnoseService.getAllAxis()
            .then((response) => {
                const data = response.data.data?.items
                if (data) {
                    setDiagnosis(data)
                }
                setLoading(false)
            })
            .catch((e) => {
                ShowToast({ type: "error", message: "Une erreur est survenue lors de la récuperation des axes" })
                setLoading(false)
            })
    }

    useEffect(() => {
        fetchAllAxis()
        fetchAllCategories()
    }, [])

    const knowledges = [
        {
            id: 1,
            content: <SvgSavoirs width="100%" />,
            screen: "Savoirs",
            code: PostCategories.knowledge
        },
        {
            id: 2,
            content: <SvgSavoirFaire width="100%" />,
            screen: "SavoirFaire",
            code: PostCategories.knowHow
        },
        {
            id: 3,
            content: <SvgSavoirEtre width="100%" />,
            screen: "SavoirEtre",
            code: PostCategories.knowHowToBe
        }
    ]

    return (
        <CustomScrollableContentWithBackHeader>
            <View style={styles.header}>
                <BreeSerifText style={styles.headerTile} fontSize={RFValue(24)}>
                    Savoirs-Faire-Être
                </BreeSerifText>

                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={14}>
                    Le contenu des rubriques savoir, savoir faire et savoir Etre est personnalisé. Vous y trouverez des
                    articles, vidéos, ateliers en direct, groupe de parole et forum pensés par l'équipe soignante
                    d'Ivehte.
                </OpenSansText>
            </View>
            {loading || fetchingUserPrograms ? (
                <ActivityIndicator color={baseColors.green.primary} style={{ padding: 20 }} size={"large"} />
            ) : (
                knowledges.map((item, index) => {
                    const disable = disableMenu && (item.id === 2 || item.id === 3)

                    return (
                        <TouchableOpacity
                            disabled={disable}
                            activeOpacity={0.5}
                            onPress={() => navigateTo(item)}
                            style={{ ...styles.marginBottom, opacity: disable ? 0.3 : 1 }}
                            key={index}
                        >
                            {item.content}
                        </TouchableOpacity>
                    )
                })
            )}
        </CustomScrollableContentWithBackHeader>
    )
}

export default Knowledge
